import { render, staticRenderFns } from "./CatalogRegistration.vue?vue&type=template&id=be36050e"
import script from "./CatalogRegistration.vue?vue&type=script&lang=js"
export * from "./CatalogRegistration.vue?vue&type=script&lang=js"
import style0 from "./CatalogRegistration.vue?vue&type=style&index=0&id=be36050e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports